import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const PodcastPlayerPage = () => {
  const { id } = useParams();
  const [podcast, setPodcast] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPodcastData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await fetch(`/api/podcasts/${id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (data && data.length > 0) {
          setPodcast(data[0]);
        } else {
          throw new Error('Podcast not found.');
        }
      } catch (err) {
        setError(err.message);
        console.error("Error fetching podcast:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPodcastData();
  }, [id]);

  const getHeaderTitle = () => {
    if (isLoading) return "Loading Podcast...";
    if (error || !podcast) return "Podcast Not Found";
    return podcast.title;
  };

  return (
    <div className="podcast-player-main">
      {isLoading && <p className="text-center p-4">Loading...</p>}
      {error && <p className="error-message p-4">Error: {error}</p>}
      {podcast && (
        <div className="podcast-player-card">
          <img src={podcast.thumbnail_url} alt={podcast.title} className="podcast-player-thumbnail" />
          <div className="podcast-player-info">
            <h2 className="podcast-player-title">{podcast.title}</h2>
            <p className="podcast-player-author">{podcast.author_name}</p>
          </div>
          <audio
            src={podcast.audio_url}
            className="podcast-audio-element"
            controls
            autoPlay
          >
            Your browser does not support the audio element.
          </audio>
        </div>
      )}
    </div>
  );
};

export default PodcastPlayerPage;
